var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-charts',{ref:"myChart",style:(_vm.customStyle ? _vm.customStyle : 'height: 100%;'),attrs:{"option":_vm.wrapperOptions,"theme":_vm.theme,"autoresize":""},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }